<template>
  <div id="app">
    <b-navbar toggleable="md" type="dark" class="custom-toolbar">
      <b-container>
        <b-navbar-brand href="/">
          <h4 class="m-0 p-0 font-size-20 font-weight-bold">CWM <small class="hidden-lg-down"><em>Cloud Workplace Management</em></small></h4>
        </b-navbar-brand>

        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="/#/download">SCARICA L'APP</b-nav-item>
            <b-nav-item href="/#/area-riservata/piani" v-if="isLogged">AREA RISERVATA</b-nav-item>
            <b-nav-item href="/#/logout" v-if="isLogged" class="ml-3 text-azure">Logout ({{ beUser.full_name }})
            </b-nav-item>
            <b-nav-item href="/#/login" class="ml-3 text-azure" v-else>Accedi</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <b-container v-if="false" fluid class="mt-5">
      <b-container class="py-4 font-size-12">
        <b-row>
          <b-col>
            <p>
              <strong>CWM</strong> - Cloud Workplace Management<br>
              Copyright © 2018 Ennova<br>
            </p>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex';

  export default {
    name: 'App',
    data: () => ({}),
    computed: {
      ...mapGetters([
        'isLogged',
        'beUser',
      ])
    },
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue